import classNames from 'classnames/bind';
import { Fragment, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import FormPayment from '../FormPayment';
import styles from './Awards.module.scss';
import { convertCurrency } from '~/configs';
import Membership from '../Mobile/Membership';
import { actionSelectAward } from '~/redux/reducer/payment';

const cx = classNames.bind(styles);

function Awards({ data, members }) {
    const { paymentSelected, awardSelected } = useSelector((state) => state.payment);

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(actionSelectAward(null));

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleSelectAward = (award) => {
        dispatch(actionSelectAward({ type: 'award', ...award }));
    };

    return (
        <div className={cx('wrapper')}>
            <div className={cx('pay')}>
                <div className={cx('left')}>
                    <div className={cx('title')}>
                        <span className={cx('icon')}></span>
                        <div className={cx('name')}>{paymentSelected?.title}</div>
                    </div>
                    <div className={cx('header')}>
                        <span className={cx('price')}>Giá</span>
                        <span className={cx('diamond')}>Thêm điểm</span>
                    </div>
                    <ul className={cx('list')}>
                        {data.map((award, index) => (
                            <li
                                key={index}
                                className={
                                    awardSelected?.title === award.title && awardSelected?.type === 'award'
                                        ? cx('item', 'active')
                                        : cx('item')
                                }
                                onClick={() => handleSelectAward(award, index)}
                            >
                                <div className={cx('check')}></div>
                                <div>
                                    <div className={cx('value')}>
                                        <span>{convertCurrency(award.amount.value)}</span>
                                    </div>
                                    <div className={cx('value-received')}>{award.title}</div>
                                </div>
                            </li>
                        ))}
                    </ul>

                    {members.length > 0 && (
                        <Fragment>
                            <div className={cx('membership')}>Thẻ thành viên tuần & tháng</div>

                            <Membership data={members} />
                        </Fragment>
                    )}
                </div>

                <div className={cx('line')}></div>

                {awardSelected ? (
                    <FormPayment />
                ) : (
                    <div className={cx('no-card')}>
                        <div className={cx('no-result')}>
                            <span>Vui lòng chọn mệnh giá tương ứng ở bên trái thanh toán</span>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}

export default Awards;
